import React from 'react';

// custom components
import { Card } from '_atoms';

// tremor 
import { Flex, Text, Metric } from "@tremor/react";

// redux
import { useSelector } from 'react-redux';
import { selectAirlineSelectedAirport } from "_redux/slices/prm-bookings/bookings";

// icons
import { BsChevronRight } from "react-icons/bs";

const SelectedAirportCard = (props) => {

    // redux
    const airport = useSelector(selectAirlineSelectedAirport);

    return (
        <Card>
            
            <Flex marginTop="mt-1" alignItems="items-start">
                <Text>Viewing bookings for</Text>
            </Flex>

            <Flex>
                <Metric>{airport}</Metric>
            </Flex>

            <Flex>
                <p style={{ marginTop: 6, marginLeft: 2, opacity: 0.6, fontSize: 12, cursor: "pointer" }} onClick={() => { props.setSelector(false), props.setAirportSelector(!props.airportSelector);}}>Select Airport</p>
                <BsChevronRight
                    onClick={() => { props.setSelector(false), props.setAirportSelector(!props.airportSelector);}}
                    size={14}
                    style={{ marginTop: -8, cursor: "pointer" }}
                    color="#307FE2"
                />
            </Flex>
        </Card>
    );
};

export default SelectedAirportCard;
